import { derive, fmtDuration, fmtInt, fmtPct, type Totals } from "../../web-analytics";

/** The five headline numbers, in NOLA's joined metric strip. Ported from Sonar's MetricStrip. */
export default function MetricStrip({ totals }: { totals: Totals }) {
  const d = derive(totals);
  const cells = [
    { label: "Visitors", value: fmtInt(totals.visitors), hint: "Unique visitors in this range" },
    { label: "Pageviews", value: fmtInt(totals.pageviews), hint: "Every page view, repeats included" },
    { label: "Views per visit", value: d.viewsPerVisit === null ? "—" : d.viewsPerVisit.toFixed(1), hint: "Pageviews divided by visits" },
    { label: "Bounce rate", value: fmtPct(d.bounceRate), hint: "Visits that saw one page and left" },
    { label: "Avg visit", value: d.avgVisitSeconds === null ? "—" : fmtDuration(d.avgVisitSeconds), hint: "Average time from first to last page view" },
  ];
  return (
    <section className="metric-grid wa-metrics" aria-label="Summary metrics">
      {cells.map((c) => (
        <article className="metric-card wa-metric" key={c.label} title={c.hint}>
          <div className="metric-top"><span>{c.label}</span></div>
          <strong className="metric-value">{c.value}</strong>
        </article>
      ))}
    </section>
  );
}
